(function () {
  if (window.__ovxsParallaxInit) return;
  window.__ovxsParallaxInit = true;

  function frame() {
    var viewportHeight = window.innerHeight;
    var els = document.querySelectorAll('[data-ovxs-parallax]');

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var speed = parseFloat(el.getAttribute('data-ovxs-parallax')) || 0;
      if (!speed) continue;

      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var target = (center - viewportHeight / 2) * speed;
      var max = rect.height * 0.22;
      if (target > max) target = max;
      if (target < -max) target = -max;

      el._ovxsPos = el._ovxsPos == null ? target : el._ovxsPos + (target - el._ovxsPos) * 0.085;
      el.style.transform = 'translate3d(0,' + el._ovxsPos.toFixed(2) + 'px,0)';
    }

    requestAnimationFrame(frame);
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    requestAnimationFrame(frame);
  }
})();
